import React, {useEffect, useRef} from 'react'
import Seo from './Seo'
import { Container, Row, Col, Button } from 'reactstrap'
import HeaderRightIMG from '../assets/images/VNC-Illustration.jpg'
import { Link } from 'react-router-dom'
import CheckIcon from '../assets/images/Check Icon.svg'
import BullsEYEIMG from '../assets/images/BullsEye-Illustration.jpg'
import ObserverIMG from '../assets/images/Observer-Illustration.jpg'
import Velocis from '../assets/images/Thumnails/Velocis-Brochure.png'
import Agilus from '../assets/images/Thumnails/Agilus-Brochure.png'
import Bullseye from '../assets/images/Thumnails/BullsEye-Brochure.png'
import VautomateIMG from '../assets/images/vAutomate-Illustration.png'
import HeroIMG from '../assets/images/Home-Page-Illustration.png'
import Contact from './conatct'
import Footer from './footer'
import CisCoIcon from '../assets/images/DNAC icon.png'
import CiscoMerakiIcon from '../assets/images/Cisco Meraki Icon.png'
import SolarWingIcon from '../assets/images/Solarwind Icon.png'
import EverestIcon from '../assets/images/Everest Icon.png'
import VaristaIcon from '../assets/images/Viptela Icon.png'
import ServiceNowIcon from '../assets/images/Service Now icon.png'
import { ScrollEffect } from 'react-easy-scroll-effect'
import 'react-easy-scroll-effect/dist/index.css'
import OwlCarousel from 'react-owl-carousel2';
import '../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import KOne from '../assets/images/01.png'
import Kytwo from '../assets/images/02.png'
import Kthree from '../assets/images/03.png'
import Kfour from '../assets/images/04.png'
import Paloalto from '../assets/images/Paloalto.png'
import Fortinet from '../assets/images/Fortinet.png'
import MicroFocus from '../assets/images/MicroFocus.png'
import MicroTeams from '../assets/images/MS-Teams.png'
import Amazon from '../assets/images/Amazon-CloudWatch.png'
import WebEx from '../assets/images/WebEx.png'
import ISEIcon from '../assets/images/ISE.png'
import WLANIcon from '../assets/images/WLAN.png'
import APCIIcom from '../assets/images/APIC.png'
import TEIcon from '../assets/images/TE.png'
import DownloadBrochure from './downloadBrochure'
import RequestDemo from './RequestDemo'



export default function Home() {
    const modalRef = useRef()
    const downlaodBroRef = useRef();

    const options = {
        items: 1,
        nav: false,
        rewind: true,
        autoplay: true
    };

    const events = {

    }

    const reqDemoClick = () =>{
        modalRef.current.openModal()
    }
    const downloadBroClick = (val) =>{
        downlaodBroRef.current.openModal()
        downlaodBroRef.current.cnameFun(val)
    }

    useEffect(()=>{
        window.scrollTo(0, 0);
        document.title = 'Home | Agilus Technologies'
    },[])

  return (
    <>
      <Seo
        title="IT Infrastructure Management Solutions"
        description="Agilus empowers businesses with transformative IT infrastructure management — automated compliance, RCA analytics, network observability and configuration automation."
        path="/"
      />
        {/* hero section */}
        <section className='py-5 custom-margin-for-header'>
            
            <Container >
                <Row>
                <Col sm={6} className='align-content'>
                <div className='dot-style'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                    <h3 className='archivo-semibold font-40'>Simply Simplifying</h3>
                    <h1 className='h1-extra-fs archivo-medium'>IT Infrastructure<br/> Management</h1>
                    <p className='mb-5 archivo-medium font-20'>Driving Digital Transformation with SDx</p>
                    <Link className='btn-custom archivo-normal' to='/about'>Know More → </Link>
                </Col>
                <Col sm={6} className='align-content'>
                <img src={HeroIMG} alt='' className='img-fluid' />
                </Col>
                </Row>
            </Container>

        </section>

        {/* key section  */}
        <section className='key-section py-5 my-4'>
        {/* <ScrollEffect id='1'> */}
            <Container className='bg-black text-white text-center custom-rounded custom-rounded-wrapper-specific p-5 '>
                <Row>
                    <Col sm={3} className='custon-border-right'>
                        <div className='key-section-icon archivo-semibold font-24'>

                            <img src={KOne} className='img-fluid'/>
                            </div>
                        <p className='fw-600'>Automating Networks Efficiency, Scalability, and Innovation at Every Step.</p>
                    </Col>
                    <Col sm={3} className='custon-border-right'>
                        <div className='key-section-icon'><img src={Kytwo} className='img-fluid' /></div>
                        <p className='fw-600'>Ensuring Network Consistency with Continuous Compliance and Auto-Remediation.</p></Col>
                    <Col sm={3} className='custon-border-right'>
                        <div className='key-section-icon'><img src={Kthree}  className='img-fluid'/></div>
                        <p className='fw-600'>Unified Visibility and Unmatched Efficiency</p>
                    </Col>
                    <Col sm={3}>
                        <div className='key-section-icon'><img src={Kfour} className='img-fluid' /></div>
                        <p className='fw-600'>Empowering Smarter IT with Analytics and AI</p>
                    </Col>
                </Row>
            </Container>
            {/* </ScrollEffect> */}
        </section>

        {/* network complience platform */}
        <section className='netwotk-complience px-3 archivo-normal'>
            <div className='bg-light-green p-5 custom-rounded align-content minHeight100vh'>
            <ScrollEffect id='2'>
                <Container>
            <Row>
                <Col sm={6} className='align-content'>
                <h1 className='archivo-semibold font-40 mb-4'>Automated Compliance, Enforcing Best Practices, Ensuring Standardization</h1>
                {/* <p className='mb-3 font-22'></p> */}
                <div className='highlight-points'>
                    <div className='highlight-points-items'>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                    Standardizing devices and configurations reduce human error and streamlines management.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Aligning with security benchmarks mitigates risks and defends against sophisticated threats.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Staying ahead of evolving regulations ensures efficiency and prevents costly disruptions.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className='mt-5'>
                                <Link className='btn-cutom-outline fw-normal' to='/compliance-engine'>Know More → </Link>
                            </Col>
                        </Row>
                    </div>
                </div>
                </Col>
                <Col sm={6} className='align-content'>
                <img src={HeaderRightIMG} alt='' className='img-fluid' />
                </Col>
            </Row>
            </Container>
            </ScrollEffect>
            </div>
        </section>

        {/* bullseye platform */}
        <section className='bullseye px-3 archivo-normal'>
            <div className='p-5 custom-rounded align-content minHeight100vh'>
            <ScrollEffect id='3'>
                <Container>
            <Row>
            <Col sm={6} className='align-content'>
                <img src={BullsEYEIMG} alt='' className='img-fluid' />
                </Col>
                <Col sm={6} className='align-content '>
                <h1 className='archivo-semibold font-40 mb-4'>Empowering IT Teams with RCA Analytics: Visualizing KPI Breaches for a Seamless User Experience</h1>
                {/* <p className='mb-3 fw-semibold'></p> */}
                <div className='highlight-points'>
                    <div className='highlight-points-items fw-semibold'>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Collects and analyzes KPI breaches across various domains, revealing critical issues impacting user experience.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Provides clear, visual insights enabling faster, data-driven decisions.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Empowers learning from RCA, applying fixes, and enhancing performance.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className='mt-5'>
                            <Link className='btn-cutom-outline fw-normal' to='/bullseye'>Know More → </Link>
                            </Col>
                        </Row>
                    </div>
                </div>
                </Col>
                
            </Row>
            </Container>
            </ScrollEffect>
            </div>
        </section>

        {/* observer platform */}
        <section className='observer px-3 archivo-normal'>
            <div className='bg-light-green p-5 align-content custom-rounded minHeight100vh'>
            <ScrollEffect id='4'>
                <Container>
            <Row>
                <Col sm={6} className='align-content'>
                <h1 className='archivo-semibold font-40 mb-4'>All-in-One Dashboard: Gain high-level network insights, comprehensive visibility, and make strategic, data-driven decisions</h1>
                {/* <p className='mb-3 fw-semibold'></p> */}
                <div className='highlight-points'>
                    <div className='highlight-points-items fw-semibold'>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Centralizes IT data to offer a complete view of infrastructure health, performance, and utilization.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Delivers actionable, real-time analytics to support data-driven decision-making and proactive management.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Empowers IT leads with metrics and trends to optimize IT investments and drive business outcomes.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className='mt-5'>
                            <Link className='btn-cutom-outline fw-normal' to='/observer'>Know More → </Link>
                            </Col>
                        </Row>
                    </div>
                </div>
                </Col>
                <Col sm={6} className='align-content'>
                <img src={ObserverIMG} alt='' className='img-fluid' />
                </Col>
            </Row>
            </Container>
            </ScrollEffect>
            </div>
        </section>

        {/* vautomate platform */}
        <section className='vautomate px-3 archivo-normal'>
            <div className='p-5 custom-rounded align-content minHeight100vh'>
            <ScrollEffect id='5'>
                <Container>
            <Row>
            <Col sm={6} className='align-content'>
                <img src={VautomateIMG} alt='' className='img-fluid' />
                </Col>
                <Col sm={6} className='align-content'>
                <h1 className='archivo-semibold font-40 mb-4'>Streamlines network operations, standardizes configurations, reduces manual errors, and enhances reliability</h1>
                {/* <p className='mb-3 fw-semibold'></p> */}
                <div className='highlight-points'>
                    <div className='highlight-points-items fw-semibold'>
                        <Row>
                            <Col className='col-1' sm={1} md={1} lg={1} xl={1} xxl={1}> <img src={CheckIcon} /></Col>
                            <Col sm={11} md={11} lg={11} xl={11} xxl={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Streamlined Network Automation with an Intuitive Interface for Maximum Efficiency
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Ensures consistent and secure configurations across all devices, reducing manual errors.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className='col-1'> <img src={CheckIcon} /></Col>
                            <Col sm={11} className='px-0 col-11'>
                                <p className='font-18 fw-normal'>
                                Intelligent Change Management: ITSM Integration with Automated Pre- and Post-Checks.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className=' mt-5'>
                            <Link className='btn-cutom-outline fw-normal' to='/vAutomate'>Know More → </Link>
                            </Col>
                        </Row>
                    </div>
                </div>
                </Col>
                
            </Row>
            </Container>
            </ScrollEffect>
            </div>
        </section>

        {/* request demo  */}
        <section className='request-demo py-5 my-4 archivo-normal'>
        <ScrollEffect id='6'>
            <Container className='bg-black text-white custom-rounded p-5 request-demo-box'>
                <Row>
                    <Col sm={12}>
                        <h1 className='font-40'>Unlock full value of your organization's IT <br/> Infrastructure platforms leveraging SDx framework</h1>
                        <button className='btn-custom mt-3 d-inline-block' onClick={()=>reqDemoClick()}>Request a Demo → </button>
                    </Col>
                </Row>
            </Container>
            </ScrollEffect>
        </section>

        {/* integration */}
        <section className='integration px-3 archivo-normal'>

        <ScrollEffect id='7'>

            <Container>
                <Row className='mb-5'>
                    <Col sm={12} className='text-center'>
                        <p><span className='marking gradient'>INTEGRATIONS</span></p>
                        <h1 className='font-45 fw-semibold'>Already Integrated <br/>with your favorite platforms</h1>
                    </Col>
                </Row>
                  <OwlCarousel options={options} events={events} >
                      <div>
                          <Row className='mb-4'>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>

                                  <img src={CisCoIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Cisco catalyst Center</h4>
                                          <small className='fw-normal'>Campus Network Controller</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={EverestIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Everest</h4>
                                          <small className='fw-normal'>ITSM</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={CiscoMerakiIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Meraki</h4>
                                          <small className='fw-normal'>Network Platform</small>
                                      </div>
                                  </div>
                              </Col>

                          </Row>
                          <Row>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={ServiceNowIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>ServiceNow</h4>
                                          <small className='fw-normal'>ITSM</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={SolarWingIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Solarwinds</h4>
                                          <small className='fw-normal'>NMS</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={Amazon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Amazon Cloudwatch</h4>
                                          <small className='fw-normal'>Cloud Monitoring</small>
                                      </div>
                                  </div>
                              </Col>
                          </Row>
                      </div>
                      <div>

                          <Row className='mb-4'>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>

                                  <img src={APCIIcom} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Cisco Catalyst SDWAN</h4>
                                          <small className='fw-normal'>SDWAN Controller</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={Paloalto} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Palo Alto Panorama</h4>
                                          <small className='fw-normal'>Firewall Controller</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={Fortinet} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Fortinet Fortimanager</h4>
                                          <small className='fw-normal'>Firewall Controller</small>
                                      </div>
                                  </div>
                              </Col>

                          </Row>
                          <Row>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={MicroFocus} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Microfocus NNMi</h4>
                                          <small className='fw-normal'>NMS</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={WLANIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Cisco ACI </h4>
                                          <small className='fw-normal'> APIC Controller</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>

                                  <img src={TEIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>ThousandEyes</h4>
                                          <small className='fw-normal'>Digital Experience Monitor</small>
                                      </div>
                                  </div>
                              </Col>
                          </Row>
                      </div>
                      <div>

                          <Row className='mb-4'>
                              
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={MicroFocus} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Microfocus NA</h4>
                                          <small className='fw-normal'>Network Automation Platform</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={WebEx} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Cisco Webex</h4>
                                          <small className='fw-normal'>Collaboration Platform</small>
                                      </div>
                                  </div>
                              </Col>
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={ISEIcon} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>Cisco ISE</h4>
                                          <small className='fw-normal'>NAC</small>
                                      </div>
                                  </div>
                              </Col>
                          </Row>
                          <Row>
                              
                              <Col sm={4}>
                                  <div className='d-flex integrated-item'>
                                  <img src={MicroTeams} className='integrated-item-Icon' />
                                      <div className='px-2'>
                                          <h4 className='mb-1'>MS Teams</h4>
                                          <small className='fw-normal'>Collaboration Platform</small>
                                      </div>
                                  </div>
                              </Col>
                          </Row>
                      </div>
                  </OwlCarousel>
                
            </Container>
            </ScrollEffect>
        </section>

        {/* Download Resources */}
        <section className='blog px-3 py-5 my-4 archivo-normal'>
            <div className='p-5 custom-rounded bg-gray-light'>
            <ScrollEffect id='8'>
                <Container>
                <Row>
                    <Col sm={12} className='text-center mb-4'>
                        <h1 className='fw-semibold'>Download Resources</h1>
                    </Col>
                    <Col sm={4}>
                        <div className='blog-item blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({title:'Simply Simplifying IT Infrastructure Management', cname:'Agilus'})}>
                            <img src={Agilus} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div>Simply Simplifying IT Infrastructure Management</div>
                            {/* <hr className='my-0'/>
                            
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className='blog-item blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({ title : 'Simply Simplifying IT Infrastructure Management',  cname : 'BullsEye'})}>
                            <img src={Bullseye} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal'><DownloadBrochure 
                            ref={downlaodBroRef}
                             />  </h5>
                              <div>A Conversational multi-domain Root Cause Analysis engine</div>
                            {/* <hr className='my-0'/>
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className='blog-item blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({ title:'Helping Organisations Get Future Ready' , cname :'Velocis Corporate Profile' })}>
                            <img src={Velocis} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div> Helping Organisations Get Future Ready </div>
                            {/* <hr className='my-0'/>
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    
                    
                    <Col sm={12} className='text-center mt-5'>
                        <Link to="/brochure" className='btn-cutom-outline'>More</Link>
                    </Col>
                </Row>
                </Container>
                </ScrollEffect>
            </div>
        </section>

        {/* contact */}
        <ScrollEffect id='9'>
        <Contact />
        </ScrollEffect>


        {/* footer */}
        <ScrollEffect id='10'>
        <Footer />
        </ScrollEffect>

        <RequestDemo  ref={modalRef}/>
    </>
  )
}
